import React, { ReactElement, useEffect, useState } from 'react'
import { ContainerFormulario } from '@pages/style'
import { Row, Col, Typography, message, Button, Spin } from 'antd'
import { HeaderPage, Input } from '@components/atoms'
import { useRouter } from '@customHooks'
import { useForm } from 'react-hook-form'
import api from '@services/api'
import { SaveOutlined } from '@ant-design/icons'

export default function FormularioMotivoPerda(): ReactElement {
  const {
    navigate,
    state,
    params: { id },
  } = useRouter<'id'>()
  const { control, reset, handleSubmit } = useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (id && state) {
      reset({ ...(state as object) })
    }
  }, [state, id])

  const onSubmit = () => {
    handleSubmit(async (values) => {
      setLoading(true)
      id
        ? await api
            .put(`/motivoperda/${id}`, values)
            .then(() => {
              setLoading(false)
              message.success('Motivo de Perda atualizado com sucesso!')
              navigate('/manutencao/auxiliares/motivoperda')
            })
            .catch(() => setLoading(false))
        : await api
            .post('/motivoperda', values)
            .then(() => {
              setLoading(false)
              message.success('Motivo de Perda cadastrado com sucesso!')
              navigate('/manutencao/auxiliares/motivoperda')
            })
            .catch(() => setLoading(false))
    })()
  }

  return (
    <ContainerFormulario>
      <HeaderPage
        title={
          id
            ? 'Atualizar motivo de perda de orçamento'
            : 'Novo motivo de perda de orçamento'
        }
        onBack={() => navigate(-1)}
        extra={[
          <Button
            key='salvar'
            icon={<SaveOutlined />}
            type='primary'
            size='large'
            loading={loading}
            onClick={onSubmit}
          >
            Salvar
          </Button>,
        ]}
      />
      <form>
        <Spin spinning={loading}>
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <Typography.Title level={5}>
                Motivo da perda de orçamento
              </Typography.Title>
              <Input
                control={control}
                name='DESCMOTIVOPERDA'
                placeholder='Descrição'
              />
            </Col>
          </Row>
        </Spin>
      </form>
    </ContainerFormulario>
  )
}
